import * as React from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import moment from 'moment';
import { sanitizeHtml } from '../../../utils/htmlSanitizer';

const useStyles = makeStyles({
  tableWrapper: {
    fontSize: '14px',
    lineHeight: 1.4,
    color: '#323130',
    fontFamily: 'Segoe UI, "Segoe UI Web (West European)", Arial, sans-serif',
    width: '100%',
    overflowX: 'auto',
    
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      margin: '0',
      textAlign: 'center'
    },
    '& th, & td': {
      padding: '5px',
      border: '1px solid black',
      textAlign: 'center'
    },
    '& th': {
      fontWeight: '600',
      whiteSpace: 'nowrap', 
      textTransform: 'uppercase',
      verticalAlign: 'middle',
      textShadow: '0px 1px 0px #ffffff',
      fontSize: '14px'
    },
    '& th:first-child, & td:first-child': {
      fontWeight: '600',
      width: '30%',
      whiteSpace: 'nowrap'        
    },
  },
  note: {
    marginTop: '8px',
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground2,
    fontStyle: 'italic'
  }
});

interface TicketTableProps {
  columns?: Array<{ key: string; label: string; type?: string }>;
  rows?: Array<Record<string, any>>;
  responseText?: string;
  suppressTextContent?: boolean;
  tableHtml?: string;
  note?: string;
}

const TicketTable: React.FC<TicketTableProps> = ({
  columns,
  rows,
  responseText,
  suppressTextContent = false,
  tableHtml,
  note
}) => {
  const styles = useStyles();

  // Format datetime values
  const formatCellValue = (value: any, columnType?: string): string => {
    if (columnType === 'datetime' && value && moment(value, moment.ISO_8601, true).isValid()) {
      return moment(value).format('DD-MMM-YYYY');
    }
    return value || '';
  };

  // Handle structured data format
  if (columns && rows) {
    return (
      <div className={styles.tableWrapper}>
        {/* {!suppressTextContent && responseText && (
          <div style={{ marginBottom: '10px' }}>{responseText}</div>
        )} */}
        <table>
          <thead>
            <tr>
              {columns.map(col => (
                <th key={col.key}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx}>
                {columns.map(col => (
                  <td key={col.key}>
                    {formatCellValue(row[col.key], col.type)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        
        {note && (
          <div className={styles.note}>
            {note}
          </div>
        )}
      </div>
    );
  }

  // Fallback for legacy HTML table format
  if (tableHtml) {
    return (
      <div className={styles.tableWrapper} dangerouslySetInnerHTML={{ __html: sanitizeHtml(tableHtml, "ticket-table") }} />
    );
  }

  // No fallback needed since table format should only show tables
  return null;
};

export default TicketTable;

// Generated by Copilot
// updated on: 2026-07-21 | 2 lines added/updated | [Auto Generated] | US 1280933 AC-3 (#12996): sanitize ticket table cell HTML via shared sanitizeHtml | Time Taken 2 min